/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskExclusionsCreate } from "../funcs/riskExclusionsCreate.js";
import { riskExclusionsDelete } from "../funcs/riskExclusionsDelete.js";
import { riskExclusionsList } from "../funcs/riskExclusionsList.js";
import { riskExclusionsListBuiltinExclusions } from "../funcs/riskExclusionsListBuiltinExclusions.js";
import { riskExclusionsSuggest } from "../funcs/riskExclusionsSuggest.js";
import { riskExclusionsUpdate } from "../funcs/riskExclusionsUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListBuiltinExclusionsResult } from "../models/components/listbuiltinexclusionsresult.js";
import { ListRiskExclusionsResult } from "../models/components/listriskexclusionsresult.js";
import { RiskExclusion } from "../models/components/riskexclusion.js";
import { SuggestExclusionResult } from "../models/components/suggestexclusionresult.js";
import {
  CreateRiskExclusionRequest,
  CreateRiskExclusionSecurity,
} from "../models/operations/createriskexclusion.js";
import {
  DeleteRiskExclusionRequest,
  DeleteRiskExclusionSecurity,
} from "../models/operations/deleteriskexclusion.js";
import {
  ListBuiltinExclusionsRequest,
  ListBuiltinExclusionsSecurity,
} from "../models/operations/listbuiltinexclusions.js";
import {
  ListRiskExclusionsRequest,
  ListRiskExclusionsSecurity,
} from "../models/operations/listriskexclusions.js";
import {
  SuggestExclusionRequest,
  SuggestExclusionSecurity,
} from "../models/operations/suggestexclusion.js";
import {
  UpdateRiskExclusionRequest,
  UpdateRiskExclusionSecurity,
} from "../models/operations/updateriskexclusion.js";
import { unwrapAsync } from "../types/fp.js";

export class Exclusions extends ClientSDK {
  /**
   * createRiskExclusion risk
   *
   * @remarks
   * Create a risk exclusion. Omit risk_policy_id to create a global exclusion that applies to every policy in the project.
   */
  async create(
    request: CreateRiskExclusionRequest,
    security?: CreateRiskExclusionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskExclusion> {
    return unwrapAsync(riskExclusionsCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteRiskExclusion risk
   *
   * @remarks
   * Delete a risk exclusion. Previously suppressed findings are restored.
   */
  async delete(
    request: DeleteRiskExclusionRequest,
    security?: DeleteRiskExclusionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(riskExclusionsDelete(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listBuiltinExclusions risk
   *
   * @remarks
   * List the built-in exclusion library (known-safe values suppressed before they reach exclusions), grouped by category.
   */
  async listBuiltinExclusions(
    request?: ListBuiltinExclusionsRequest | undefined,
    security?: ListBuiltinExclusionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListBuiltinExclusionsResult> {
    return unwrapAsync(riskExclusionsListBuiltinExclusions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listRiskExclusions risk
   *
   * @remarks
   * List risk exclusions for the current project. Optionally filter to a single policy.
   */
  async list(
    request?: ListRiskExclusionsRequest | undefined,
    security?: ListRiskExclusionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListRiskExclusionsResult> {
    return unwrapAsync(riskExclusionsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * suggestExclusion risk
   *
   * @remarks
   * Suggest a risk exclusion (match_type, match_value, filters) from a natural-language prompt, a batch of example findings, or both. Calls the configured LLM with a JSON-schema constrained response so the dashboard can prefill the create exclusion form. At least one of prompt or finding_ids is required.
   */
  async suggest(
    request: SuggestExclusionRequest,
    security?: SuggestExclusionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SuggestExclusionResult> {
    return unwrapAsync(riskExclusionsSuggest(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateRiskExclusion risk
   *
   * @remarks
   * Update a risk exclusion.
   */
  async update(
    request: UpdateRiskExclusionRequest,
    security?: UpdateRiskExclusionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskExclusion> {
    return unwrapAsync(riskExclusionsUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
